import AppointmentForm from './AppointmentForm';

export default AppointmentForm;
